import { createPageNavigator } from "@-/dev.improve.haniverse.lib.navigator.page";
import { useCallback } from "react";

function useNavigator() {
  return useCallback(
    () => ({
      href: {
        pathname: "/(nav)/(app)/settings/about",
      },
      queries: [],
    }),
    [],
  );
}

export const useAboutSettingsPageNavigator = createPageNavigator<void>({
  useNavigator,
});
